export const FETCH_FAQS_DATA = "FETCH_FAQS_DATA";
export const FETCH_FAQS_SUCCESS = "FETCH_FAQS_SUCCESS";
export const FETCH_FAQS_FAILURE = "FETCH_FAQS_FAILURE";

export const FETCH_FAQS_EDIT_DATA = "FETCH_FAQS_EDIT_DATA";
export const FETCH_FAQS_EDIT_SUCCESS = "FETCH_FAQS_EDIT_SUCCESS";
export const FETCH_FAQS_EDIT_FAILURE = "FETCH_FAQS_EDIT_FAILURE";